import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  //  {path :'', redirectTo: 'login', pathMatch: 'full' },
  //  {path :'login', component:LoginComponent}
  //{ path: 'home', component: HomeComponent ,canActivate:[AuthGaurdService]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
